import React, { useState } from 'react';
import { Add, EmailOutlined, Remove } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { EmailSearchResult } from '../../api-client/autogenerated';
import { Collapse } from '@material-ui/core';
import { descendingComparator } from '../document-index/DocumentIndexUtils';
import EmailSearchItem from './EmailSearchItem';

interface EmailSearchResultsProps {
  emails: EmailSearchResult[];
  searchTerm: string;
  keywordSearchTerms: string[];
  filters: {
    createdBeforeDate?: string;
    createdAfterDate?: string;
  };
}

export default function EmailSearchResults(props: EmailSearchResultsProps) {
  const { emails, searchTerm, keywordSearchTerms, filters } = props;

  const [open, setOpen] = useState(true);

  return (
    <Paper
      style={{
        marginBottom: 8,
        boxShadow: '1px 1px 10px 1px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        onClick={() => setOpen((prev) => !prev)}
        style={{
          display: 'flex',
          position: 'relative',
          alignItems: 'center',
          padding: 16,
          borderBottom: '1px solid #DCDCDC',
          cursor: 'pointer',
          zIndex: 10,
        }}
      >
        <EmailOutlined
          htmlColor="#0247B9"
          style={{ fontSize: 26, marginRight: 9, marginLeft: -2 }}
        />
        <Typography style={{ fontSize: '18px', lineHeight: '24px', fontWeight: 700 }}>
          Emails ({emails.length})
        </Typography>
        <div style={{ display: 'inline-flex', flexGrow: 100 }} />
        <IconButton style={{ padding: 0 }}>{open ? <Remove /> : <Add />}</IconButton>
      </div>
      <Collapse in={open}>
        {emails
          .sort((a, b) => descendingComparator(a, b, 'sendDate'))
          .map((e) => (
            <EmailSearchItem
              key={e.id}
              email={e}
              searchTerm={searchTerm}
              keywordSearchTerms={keywordSearchTerms}
              filters={filters}
            />
          ))}
      </Collapse>
    </Paper>
  );
}
